import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.div`
  background: linear-gradient(145deg, #ffffff, #f5f6fa);
  border-radius: 14px;
  padding: 16px;
  box-shadow: 
    4px 4px 10px rgba(0, 0, 0, 0.05),
    -4px -4px 10px rgba(255, 255, 255, 0.8);
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #4a6fa1;
  margin: 0 0 10px 0;
`;

const SectionDescription = styled.p`
  font-size: 14px;
  color: #8c96a5;
  margin: 0 0 12px 0;
`;

const SettingsSection = ({ title, description, children }) => {
  return (
    <SectionContainer>
      {title && <SectionTitle>{title}</SectionTitle>}
      {description && <SectionDescription>{description}</SectionDescription>}
      {children}
    </SectionContainer>
  );
};

export default SettingsSection;